export default __webpack_public_path__ + "static/media/price-monitoring.26831185.jpg";